<app-content-body [isCentralized]='true' height='90vh'>

    <div class="container">

        <div class="row justify-content-center py-5">

            <div class="col-md-5 border rounded shadow-sm p-4">

                <!-- Logo -->
                <img class="img-fluid mb-4 logoheight" src="https://www.alachisoft.com/images/logo-d.svg" alt="NCache" />
                
                <!-- Form for Forgot Password -->
                <form [formGroup]="this.emailFormGroup" (ngSubmit)="onEmailFormSubmit()" *ngIf="!isResetLinkSent">

                    <div class="mb-3">

                        <h2 class="passowrdlabel">Forgot Password</h2>
                        <p class="mb-4">A reset link will be sent to the following email</p>
                        
                        <!-- Email Input -->
                        <input 
                            type="email" 
                            formControlName="email" 
                            class="form-control" 
                            placeholder="Enter Email" 
                            appAutoFocus 
                            [ngClass]="{ 'is-invalid': this.emailFormSubmitted && this.emailForm }" 
                            maxlength="128"
                        />

                        <!-- Validation Feedback -->
                        <div *ngIf="this.emailFormSubmitted && this.emailForm.email.errors" class="invalid-feedback">
                            <div *ngIf="this.emailForm.email.errors.required">Email is required</div>
                            <div *ngIf="this.emailForm.email.errors.email">Email is invalid</div>
                        </div>

                    </div>

                    <!-- Action Buttons -->
                    <div class="d-flex justify-content-between align-items-center">
                        <button type="button" (click)="navigateToLogin($event)" class="btn btn-link px-0">Go Back</button>
                        <button [disabled]="this.isSendingResetLink" class="btn btn-primary">
                            <span *ngIf="this.isSendingResetLink" class="spinner-border spinner-border-sm me-1"></span>
                            Send
                        </button>
                    </div>

                </form>

                <!-- Email Sent Confirmation -->
                <div *ngIf="this.isResetLinkSent">

                    <h2 class="my-5 text-center text-success">An email has been sent to {{this.emailForm.email.value}}</h2>

                    <button type="button" (click)="navigateToLogin($event)" class="btn btn-link px-0">Go Back</button>

                </div>

            </div>

        </div>

    </div>

</app-content-body>
